export default "__VITE_ASSET__DKRbxlC1__"